<div class="ppl-container-body">
  <div class="ppl-container-head">
    <div class="d-flex justify-content-between">
      <div class="mt-2">Create New {{getTitle()}}</div>
      <ppl-button label="" ariaLabel="Close" icon="fa fa-close" [customClass]="'rounded close-popup'"
        [iconPosition]="'left'" (handleClick)="returnClicked()">
        ></ppl-button>
    </div>

    <div class="action">
      @if(showTrackingInfo){
      <div class="tracking-info">
        @if(trackingNumber){
        <div class="tracking-number">
          <strong class="primary-color-text">Tracking Number: </strong>{{trackingNumber}}
        </div>
        }

        @if(providerPPLId || participantPPLId){
        <div class="tracking-ppl-id">
          <strong class="primary-color-text">PPL ID: </strong> {{providerPPLId || participantPPLId}}
        </div>
        }
      </div>
      }
    </div>
  </div>

  <div class="wiz-body">
    <div class="Sidebar">
      <ppl-steps class="steps" (stepSelected)=stepSelected($event)
        (showTrackingInformation)=showTrackingInformation($event) (showConfirmation)=showConfirmation($event)
        (stepEnter)="focusOnContent()" (showProcessingMessage)="showProcessingMessage()"></ppl-steps>
    </div>
    <div class="wiz-container" #wizContainer>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<ppl-popup-dialog [(isVisible)]="show" [title]="'Confirmation'" [isOkText]="'Close'" (cancel)="onClose()"
  [showButtons]="false" [position]="'top'" size="medium" [showOkButton]="true">
  @if(!isApproved){
  <div class="ppl-p24">
    <p class="ppl-gray-text ppl-mt20">
      Thank you for your submission!<br>
      Your tracking number is <b>{{trackingNumber}}</b>.<br>
      @if(pplId){
      Your PPL ID is <b>{{pplId}}</b>.<br><br>
      }
      @if(healthAssessmentVendor === 'The IMA Group'){
        PPL works with trusted, approved partners to conduct health assessments for CDPAP personal assistants (PAs). Your health assessment provider The IMA Group will contact you directly to schedule your assessment. If you have any questions, contact The IMA Group at <a href="tel:1-844-540-1882">1-844-540-1882</a> or <a href="mailto:PPL@theIMAgroup.com">PPL&#64;theIMAgroup.com</a>. For more information on the health assessment requirement, go to <a href="https://pplfirst.com/cdpap-health-assessments" target="_blank" rel="noopener noreferrer">https://pplfirst.com/cdpap-health-assessments</a>.
      }
      @if(healthAssessmentVendor === 'Mobile Health'){
        PPL works with trusted, approved partners to conduct health assessments for CDPAP personal assistants (PAs). Your health assessment provider is Mobile Health. Please visit <a href="https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings" target="_blank" rel="noopener noreferrer">www.mobilehealth.com/ny-cdpap-ppl-medical-screenings</a> to complete your health assessment as soon as possible. If you have any questions, contact Mobile Health at <a href="tel:646-680-0450">646-680-0450</a> or email <a href="mailto:ppl@mobilehealth.com">ppl&#64;mobilehealth.com</a>. For more information on the health assessment requirement, go to <a href="https://pplfirst.com/cdpap-health-assessments" target="_blank" rel="noopener noreferrer">https://pplfirst.com/cdpap-health-assessments</a>.
      }
      One of our team members will be in touch with you to complete your registration.
    </p>
  </div>
  }
  @else {
  <div class="ppl-p24">
    <p class="ppl-gray-text ppl-mt20">
      Thank you for your submission. Your tracking number is <b>{{trackingNumber}}</b>.
    </p>
    @if(app_status === 'RN'){
      <p class="ppl-gray-text">
        This referral has been sent to PPL's Enrollment Team for review.
      </p>
      <p class="ppl-gray-text">
        You can track the status of referrals from the Consumer Referral menu. Once the review is complete, the consumer will be notified of any next steps.
      </p>
    }
    @else {
      <p class="ppl-gray-text">
        The consumer will be sent a link to begin registration via the preferred contact method you selected for them.
      </p>
    }
    <!-- <div class="ppl-p8">
      <p class="options" (click)="sendComm('email')"><span class="btn-color" nz-icon nzType="laptop"
          nzTheme="outline"></span><strong>Email</strong></p>
      <p class="options" (click)="sendComm('sms')"><span class="btn-color" nz-icon nzType="shake"
          nzTheme="outline"></span><strong>SMS</strong></p>
    </div> -->
  </div>
  }
</ppl-popup-dialog>

<ppl-popup-dialog [(isVisible)]="showProcessing" [title]="'Submission Received'" [isOkText]="'Close'"
  (cancel)="onProcessingClose()" [showButtons]="false" [position]="'top'" size="medium" [showOkButton]="true">
  <div class="ppl-p24">
    <p class="ppl-gray-text ppl-mt20">
      Your submission is currently being processed.<br>
      Please check back later to verify that it was submitted successfully.
    </p>
  </div>
</ppl-popup-dialog>

<ppl-popup-dialog [(isVisible)]="showAssociation" [title]="getEnrollmentPageTitle(currentFlow)" [isOkText]="'Save'"
  (confirm)="handleSaveAssociations()" (cancel)="closePopup()" [showButtons]="true" [position]="'top'" size="x-large"
  [showClose]="true" [showOkButton]="false" [hideSaveButton]="hideSaveBtn()" [styleClass]="'association-popup'">
  @if(showAssociation){
  <div>
    <ppl-new-enrollment [mode]="editAssociationMode" [flow]="currentFlow"
      (confirm)="handleSaveAssociations()"></ppl-new-enrollment>
  </div>
  }
</ppl-popup-dialog>

<ppl-popup-dialog [(isVisible)]="showCDPAPModal" title="CDPAP Facilitator"
  [isOkText]="isAlgoMode ? 'Search Facilitator' : 'Save'" (confirm)="handleConfirmCDPAP()"
  (cancel)="onCloseCDPAPPopup()" [showButtons]="isAlgoMode" [position]="'top'" [size]="cdpapModalSize"
  [showClose]="true" [showOkButton]="false" [hideSaveButton]="formReadonly">
  <ppl-cdpap-form #cdPapFormRef (stepBack)="handleCDPAPStepBack()"></ppl-cdpap-form>
</ppl-popup-dialog>